import React from "react";

import Button from "@material-ui/core/Button";

import moment from "moment";

import { getDollarValue } from "../../helpers";
import {
  CreditCard,
  WebAsset,
  FileCopy,
  DeleteForever as Delete,
} from "@material-ui/icons";
import { hashHistory } from "browserHistory";
import { openConfirm } from "components/confirmBox/ConfirmBox";

const OrderItem = (props) => {
  const {
    order,
    editorActions,
    useGuid,
    actions,
    fromCheckout = false,
    hideDelete = false,
  } = props;

  return (
    <div
      style={{ border: "1px solid #dddddd", marginBottom: 10 }}
      key={`or_${order.id}`}
    >
      <div
        style={{
          display: "flex",
          whiteSpace: "nowrap",
          backgroundColor: "#f6f6f6",
          borderBottom: "1px solid #dddddd",
        }}
      >
        <div style={{ margin: 10, width: "100%" }}>Order # {order.id}</div>
        {/* <div style={{ margin: 10 }}>{moment(e.date).format('MMM Do, YYYY h:mm A')}</div>
        <div style={{ margin: 10 }}>Total: {getDollarValue(e.total)}</div> */}
      </div>
      <div style={{ borderBottom: "1px solid #dddddd", fontSize: 14 }}>
        <div style={{ display: "flex", margin: 10 }}>
          <div style={{ width: 150 }}>Order Date</div>
          <div>
            {moment.utc(order.date).local().format("MMM Do, YYYY h:mm A")}
          </div>
        </div>
        <div style={{ display: "flex", margin: 10 }}>
          <div style={{ width: 150 }}>Subtotal</div>
          <div>{getDollarValue(order.subTotal)}</div>
        </div>
        {order.payedByCredits > 0 && (
          <div style={{ display: "flex", margin: 10 }}>
            <div style={{ width: 150 }}>Account Credits Used</div>
            <div>{getDollarValue(order.payedByCredits)}</div>
          </div>
        )}
        <div style={{ display: "flex", margin: 10 }}>
          <div style={{ width: 150 }}>Taxes</div>
          <div>{getDollarValue(order.taxes)}</div>
        </div>
        <div style={{ display: "flex", margin: 10 }}>
          <div style={{ width: 150 }}>Order Total</div>
          <div>{getDollarValue(order.total)}</div>
        </div>

        {order.payedByCard > 0 && (
          <div style={{ display: "flex", margin: 10 }}>
            <div style={{ width: 150 }}>Paid by Credit Card</div>
            <div>{getDollarValue(order.payedByCard)}</div>
          </div>
        )}
        <div style={{ display: "flex", margin: 10 }}>
          <div style={{ width: 150 }}>Order Currency</div>
          <div>{order.currency ? order.currency : "CAD"}</div>
        </div>
        {order.externalReceiptUrl && (
          <div style={{ margin: 10 }}>
            <Button
              variant={"text"}
              color={"primary"}
              onClick={() => {
                window.open(order.externalReceiptUrl, "_blank");
              }}
            >
              <CreditCard style={{ marginRight: 10 }} /> View Credit Card
              Receipt
            </Button>
          </div>
        )}
      </div>
      {order.portfolios.map((p, i) => (
        <div key={`po_${p.id}`}>
          {!p.isDeleted && (
            <div
              style={{
                borderBottom:
                  i !== order.portfolios.length - 1 ? "1px solid #dddddd" : "",
                padding: 10,
              }}
            >
              <div style={{ display: "flex" }}>
                <div style={{ width: "100%" }}>
                  <div style={{ margin: 5 }}>Portfolio: {p.name}</div>
                  <div style={{ fontSize: 14, color: "#757575", margin: 5 }}>
                    Analysis Period:{" "}
                    {moment(p.startDate).format("MMM Do, YYYY")} to{" "}
                    {moment(p.endDate).format("MMM Do, YYYY")}{" "}
                  </div>
                </div>
                <div style={{ width: 130 }}>
                  <div style={{ whiteSpace: "nowrap", textAlign: "right" }}>
                    <Button
                      fullWidth
                      variant={"outlined"}
                      color={"primary"}
                      onClick={() => {
                        window.open(
                          `/#/Portfolio/${useGuid ? p.uniqueId : p.id}`,
                          "_blank",
                        );
                      }}
                    >
                      {" "}
                      <WebAsset style={{ marginRight: 10 }} />{" "}
                      {fromCheckout ? "View Report" : "View"}
                    </Button>
                  </div>
                  {editorActions && (
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        textAlign: "right",
                        marginTop: 10,
                      }}
                    >
                      <Button
                        fullWidth
                        variant={"outlined"}
                        color={"primary"}
                        onClick={() => {
                          editorActions.copyPortfolio(p.id, () => {
                            hashHistory.push("/DataEntry/Edit");
                          });
                        }}
                      >
                        {" "}
                        <FileCopy style={{ marginRight: 10 }} />
                        Copy
                      </Button>
                    </div>
                  )}
                  {editorActions && !hideDelete && (
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        textAlign: "right",
                        marginTop: 10,
                      }}
                    >
                      <Button
                        fullWidth
                        variant={"outlined"}
                        color={"primary"}
                        onClick={() => {
                          openConfirm({
                            title: "Confirm Deletion",
                            description: (
                              <div>
                                <div>
                                  Are you sure you want to permanently delete
                                  this portfolio?
                                </div>
                                <div
                                  style={{ fontWeight: "bold", marginTop: 20 }}
                                >
                                  This cannot be undone.
                                </div>
                                <div style={{ marginTop: 20 }}>
                                  Make sure to download a copy first by viewing
                                  the report and printing it to a PDF file.
                                </div>
                              </div>
                            ),
                            callback: () => {
                              actions.deletePortfolio(p.id, order.id);
                            },
                          });
                        }}
                      >
                        {" "}
                        <Delete style={{ marginRight: 10 }} /> Delete
                      </Button>
                    </div>
                  )}
                </div>
              </div>
              {useGuid && (
                <div
                  style={{
                    margin: 10,
                    padding: 10,
                    borderRadius: 5,
                    backgroundColor: "#daebff",
                    border: "1px solid #6b7fff",
                  }}
                >
                  <div style={{ fontSize: 16, margin: 5 }}>
                    Analysis Direct Link
                  </div>
                  <div style={{ fontSize: 14, margin: 5 }}>
                    Here is the direct link to your report. Do not lose it as it
                    is the only way to access your report!
                  </div>
                  <div
                    style={{ marginTop: 10, marginBottom: 10, marginLeft: 5 }}
                  >{`${window.location.protocol}//${window.location.host}/#/Portfolio/${p.uniqueId}`}</div>
                  <div style={{ fontSize: 12, margin: 5 }}>
                    Note: This link will also be sent to your email, as part of
                    your receipt.
                  </div>
                </div>
              )}
            </div>
          )}
          {p.isDeleted && (
            <div
              style={{
                borderBottom:
                  i !== order.portfolios.length - 1 ? "1px solid #dddddd" : "",
                padding: 10,
              }}
            >
              <div style={{ display: "flex" }}>
                <div style={{ width: "100%" }}>
                  <div style={{ fontSize: 14, color: "#757575", margin: 5 }}>
                    Portfolio Deleted
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default OrderItem;



// WEBPACK FOOTER //
// ./src/account/components/OrderItem.js